import { Link } from "react-router-dom";
import { WaveformMark } from "./Logo";
import { EMAIL, PHONE_DISPLAY, PHONE_TEL } from "../../constants/site";

const SERVICE_LINKS = [
  { href: "/corporate-tscm", label: "Corporate TSCM inspection" },
  { href: "/preventive-tscm", label: "Preventive TSCM" },
  { href: "/live-meeting-monitoring", label: "Live meeting monitoring" },
];

export default function Footer() {
  return (
    <footer className="border-t border-hairline py-12 sm:py-16" data-testid="site-footer">
      <div className="site-x">
        <div className="flex flex-col justify-between gap-8 sm:flex-row sm:items-start">
          <div className="flex items-center gap-3">
            <WaveformMark className="h-5 w-auto text-violet" />
            <span className="leading-none">
              <span className="block font-head text-[0.9375rem] font-extrabold tracking-tight">
                TSCM Services
              </span>
              <span className="mt-1 block text-[0.5625rem] uppercase tracking-[0.16em] text-sub">
                The corporate TSCM arm of Law Abiding Technology (LAT)
              </span>
            </span>
          </div>
          <nav className="flex flex-col gap-2 sm:text-right" aria-label="Services">
            {SERVICE_LINKS.map(({ href, label }) => (
              <Link
                key={href}
                to={href}
                data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-sm text-sub transition-colors hover:text-violet"
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-10 border-t border-hairline pt-6 text-xs leading-relaxed text-sub">
          <p>
            <strong className="font-semibold text-ink">Law Abiding Technology (LAT)</strong>, a
            partnership firm. <strong className="font-semibold text-ink">TSCM Services</strong> is
            its corporate TSCM arm.
          </p>
          <p className="mt-2">GSTIN: 09AACFL4204H1ZL</p>
          <p className="mt-2">
            UM-A-106A, Upper Mezzanine Floor, Ansal Plaza, Vaishali, Ghaziabad 201010
          </p>
          <p className="mt-2">
            Lead practitioner: Rajiv Vermani, founder of Law Abiding Technology
          </p>
          <p className="mt-2">
            <a href={PHONE_TEL} data-testid="footer-phone-link" className="transition-colors hover:text-violet">
              {PHONE_DISPLAY}
            </a>
            {" · "}
            <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="transition-colors hover:text-violet">
              {EMAIL}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
